import Icon from '../components/Icon.vue'

Icon.register({
  'luggage-cart': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M224 320c-17.7 0-32-14.3-32-32v-160c0-17.7 14.3-32 32-32h32v224h-32zM576 288c0 17.7-14.3 32-32 32h-32v-224h32c17.7 0 32 14.3 32 32v160zM624 384c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-82.9c1.8 5 2.9 10.4 2.9 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1.2-11 2.9-16h-197.9c1.8 5 2.9 10.4 2.9 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1.2-11 2.9-16h-82.9c-8.8 0-16-7.2-16-16v-368h-48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v368h496zM480 96v224h-192v-272c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v48zM432 96v-48h-96v48h96z'
      }
    ]
  }
})
